<fieldset [ngClass]="props.fieldsetClass">
  <div [ngClass]="props.childClass">
    <legend *ngIf="props.legend" [ngClass]="props.legendClass">{{ props.legend | translate }}</legend>
    <formly-field *ngFor="let f of field.fieldGroup" [field]="f"></formly-field>
  </div>
</fieldset>
